import { z } from 'zod/v3';

import { cursorPagedMarketProductsSchema } from './market-products';

/** 쇼케이스 요약 (ShowcaseResponse) — 쇼케이스 그룹의 탭 항목 */
export const showcaseSummarySchema = z.object({
  /** 쇼케이스 코드 */
  code: z.string(),
  /** 쇼케이스 ID */
  id: z.number(),
  /** 쇼케이스 이름 */
  name: z.string().optional(),
  /** 메인 이미지 url */
  mainImageUrl: z.string().optional(),
});
export type ShowcaseSummary = z.infer<typeof showcaseSummarySchema>;

/** 쇼케이스 그룹 (ShowcaseGroupResponse) */
export const showcaseGroupSchema = z
  .object({
    /** 쇼케이스 그룹 코드 */
    code: z.string().optional(),
    /** 그룹 이름 */
    name: z.string().optional(),
    /** 설명 */
    description: z.string().optional(),
    /** 메인 이미지 url */
    mainImageUrl: z.string().optional(),
    /** 썸네일 이미지 url */
    thumbnailImageUrl: z.string().optional(),
    /** 쇼케이스 목록 */
    showcases: z.array(showcaseSummarySchema),
  })
  .passthrough();
export type ShowcaseGroup = z.infer<typeof showcaseGroupSchema>;

/** 쇼케이스 상품 응답 (MarketShowcaseProductsResponseV3) */
export const showcaseProductsSchema = z
  .object({
    /** 쇼케이스 코드 */
    code: z.string().optional(),
    /** 쇼케이스 상품 수 */
    count: z.number().optional(),
    /** 쇼케이스 이름 */
    name: z.string().optional(),
    /** 쇼케이스 설명 */
    description: z.string().optional(),
    /** 메인 이미지 */
    mainImageUrl: z.string().optional(),
    /** 썸네일 이미지 */
    thumbnailImageUrl: z.string().optional(),
    /** 상품 목록 (커서 페이지네이션) */
    products: cursorPagedMarketProductsSchema.optional(),
  })
  .passthrough();
export type ShowcaseProducts = z.infer<typeof showcaseProductsSchema>;
